<template>
    <div>
        <v-text-field v-if="getField(field)" :type="field.TYPE === 'ND' ? 'number' : 'text'"
            :disabled="field ? field.DISABLED : false" :rules="getValidators(field)" :label="getLabel(field)"
            append-outer-icon="mdi-account-search" @click:append-outer="openContactDialog" :value="value"
            @input="updateValue"></v-text-field>

        <v-dialog v-model="showContactSelector" max-width="800px">
            <v-card>
                <v-card-title>
                    <v-text-field v-model="search" label="Search" append-icon="mdi-magnify" />
                </v-card-title>
                <v-card-text>
                    <v-data-table :headers="headers" :items="contacts" :search="search" :items-per-page="5"
                        item-key="id">
                        <template v-slot:item.actions="{ item }">

                            <v-btn class="ma-2" text icon color="primary" @click="selectContact(item)">
                                <v-icon>mdi-account-check</v-icon>
                            </v-btn>
                            <!--    <v-icon color="primary" small @click="selectContact(item)">mdi-account-check</v-icon> -->
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>
import fieldMixin from '../mixins/field';
import helperMixin from '../mixins/helper';
import axios from 'axios';

export default {
    name: 'aedContactSelector',
    mixins: [fieldMixin, helperMixin],
    props: {
        field: Object,
        value: String, // 'value' is declared as a prop
    },
    data() {
        return {
            headers: [],
            contacts: [],
            search: "",
            showContactSelector: false,

        };
    },

    mounted() {

        if (this.field && this.field.VALUE) {
            this.value = this.field.VALUE
        }

    },


    methods: {

        updateValue(newValue) {
            this.$emit('input', newValue);
        },
        openContactDialog() {
            this.showContactSelector = true;
            this.getContactHeaders();
            this.getContacts("EMPF");
        },


        async getContacts(addressType) {
            const t = this;
            t.contacts.data = [];
            t.$store.commit('setLoadingState', true);

            let params = {
                typ: addressType,
                opcode: "L",
                format: "J"
            }



            try {
                const response = await axios({
                    method: 'get', url: process.env.VUE_APP_BACKEND_CONTACTS, params, withCredentials: true
                });

                // handle success

                t.contacts = response.data;
                if (t.contacts.length === 1) {
                    t.selectContact(t.contacts[0]);
                }

            } catch (error) {
                // handle error
                t.$store.dispatch("showMessage", { type: "Error", text: error.message });
                console.log(error);
            } finally {
                // always executed
                t.$store.commit('setLoadingState', false);
            }
        },

        selectContact(contact) {

            this.$emit('input', contact.key1);
            this.showContactSelector = false;
        },

        getContactHeaders() {
            const t = this;
            t.$store.commit('setLoadingState', true);


            axios({
                method: 'post', url: process.env.VUE_APP_BACKEND_CONTACTS, params: {
                    opcode: "JO",
                    format: "J"
                }, withCredentials: true
            })
                .then(function (response) {
                 
                    // handle success


                    const resultArray = Object.keys(response.data).map(key => ({
                        value: key,
                        text: response.data[key].NAME
                    }));
                    t.headers = resultArray;
                    t.headers.push({ text: "Actions", value: "actions", align: "left" });


                })
                .catch(function (error) {
                    // handle error
                    t.$store.dispatch("showMessage", { type: "Error", text: error.message });

                    console.log(error);
                })
                .finally(function () {
                    // always executed

                    t.$store.commit('setLoadingState', false);

                });
        },



    },
};
</script>